<template>
  <div id="app">
    <dv-full-screen-container class="top">
      <div class="top-bg">
        <p class="top-text">{{ topTitle }}</p>
        <div class="top-right-btn">
          <span class="top-button n-change">
            <el-dropdown>
              <span class="el-dropdown-link">
                切换报表<i class="el-icon-caret-bottom el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item @click.native="indexClick"
                  >首页面</el-dropdown-item
                >
                <el-dropdown-item @click.native="collectionClick"
                  >回款分析</el-dropdown-item
                >
                <el-dropdown-item @click.native="achievementClick"
                  >业绩分析</el-dropdown-item
                >
                <el-dropdown-item @click.native="managementClick"
                  >经营分析</el-dropdown-item
                >
                <el-dropdown-item @click.native="businessClick"
                  >业务分析</el-dropdown-item
                >
                <el-dropdown-item @click.native="personnelClick"
                  >人员分析</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </span>
          <span
            class="top-button fullScreen"
            @click="toggleFullscreen"
            v-show="is"
          >
            全屏
            <i class="icon-all">
              <svg
                width="14px"
                height="14px"
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="BI报表"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="BI业绩大数据"
                    transform="translate(-1865.000000, -41.000000)"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  >
                    <g id="顶部" transform="translate(0.000000, -8.000000)">
                      <g
                        id="编组-22"
                        transform="translate(1708.000000, 39.000000)"
                      >
                        <g
                          id="编组-2"
                          transform="translate(108.000000, 0.000000)"
                        >
                          <g
                            id="全屏_o_export"
                            transform="translate(49.000000, 10.000000)"
                          >
                            <g
                              id="全屏_o"
                              transform="translate(1.000000, 1.000000)"
                            >
                              <path
                                d="M1.35540675,11.1173115 L3.18080357,11.1173115 L3.18080357,11.9109623 L0.00620039063,11.9109623 L0.00620039063,8.73635913 L0.79985119,8.73635913 L0.79985119,10.561756 L3.18080357,8.18080357 L3.73635913,8.73635913 L1.35540675,11.1173115 Z M10.561756,11.1173115 L8.18080357,8.73635913 L8.73635913,8.18080357 L11.1173115,10.561756 L11.1173115,8.73635913 L11.9109623,8.73635913 L11.9109623,11.9109623 L8.73635913,11.9109623 L8.73635913,11.1173115 L10.561756,11.1173115 Z M1.35540675,0.79985119 L3.73635913,3.18080357 L3.18080357,3.73635913 L0.79985119,1.35540675 L0.79985119,3.18080357 L0.00620039063,3.18080357 L0.00620039063,0.00620039063 L3.18080357,0.00620039063 L3.18080357,0.79985119 L1.35540675,0.79985119 Z M10.561756,0.79985119 L8.73635913,0.79985119 L8.73635913,0.00620039063 L11.9109623,0.00620039063 L11.9109623,3.18080357 L11.1173115,3.18080357 L11.1173115,1.35540675 L8.73635913,3.73635913 L8.18080357,3.18080357 L10.561756,0.79985119 Z"
                                id="形状"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </i>
          </span>
          <span
            class="top-button fullScreen"
            @click="toggleFullscreen"
            v-show="!is"
          >
            退出
            <i class="icon-all">
              <svg
                width="14px"
                height="14px"
                viewBox="0 0 14 14"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
              >
                <g
                  id="BI报表"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                >
                  <g
                    id="BI业绩大数据"
                    transform="translate(-1865.000000, -85.000000)"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  >
                    <g id="顶部" transform="translate(0.000000, -8.000000)">
                      <g
                        id="编组-22"
                        transform="translate(1708.000000, 39.000000)"
                      >
                        <g
                          id="编组-2备份"
                          transform="translate(108.000000, 44.000000)"
                        >
                          <g
                            id="全屏_o_export"
                            transform="translate(49.000000, 10.000000)"
                          >
                            <g
                              id="全屏_o"
                              transform="translate(1.000000, 1.000000)"
                            >
                              <path
                                d="M2.38715277,8.97445435 L0.561755952,8.97445435 L0.561755952,8.18080357 L3.73635913,8.18080357 L3.73635913,11.3554067 L2.94270833,11.3554067 L2.94270833,9.53000991 L0.561755952,11.9109623 L0.00620039063,11.3554067 L2.38715277,8.97445435 Z M9.53000991,8.97445435 L11.9109623,11.3554067 L11.3554067,11.9109623 L8.97445435,9.53000991 L8.97445435,11.3554067 L8.18080357,11.3554067 L8.18080357,8.18080357 L11.3554067,8.18080357 L11.3554067,8.97445435 L9.53000991,8.97445435 Z M2.38715277,2.94270833 L0.0062003906,0.561755952 L0.561755952,0.00620039063 L2.94270833,2.38715277 L2.94270833,0.561755952 L3.73635913,0.561755952 L3.73635913,3.73635913 L0.561755952,3.73635913 L0.561755952,2.94270833 L2.38715277,2.94270833 Z M9.53000991,2.94270833 L11.3554067,2.94270833 L11.3554067,3.73635913 L8.18080357,3.73635913 L8.18080357,0.561755952 L8.97445435,0.561755952 L8.97445435,2.38715277 L11.3554067,0.00620039063 L11.9109623,0.561755952 L9.53000991,2.94270833 Z"
                                id="形状"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg>
            </i>
          </span>
        </div>
      </div>
      <!-- <dv-active-ring-chart
        ref="pie2"
        :key="key"
        class="datav-item"
      > -->
      <router-view />
      <!-- </dv-active-ring-chart> -->
    </dv-full-screen-container>
  </div>
</template>

<script>
//import $ from "jquery";
import "../src/assets/js/flexible.js";
export default {
  data() {
    return {
      topTitle: "锐仕方达运营大数据中心",
      // 设置flag用于判断是否进入全屏
      flag: 0,
      is: true,
      key: 1,
      urlData: this.$changeData,
    };
  },

  methods: {
    pieOutlineFunc() {
      var bodydom = document.body;
      var editordom = document.getElementById("editor");
      var defwidth = 1920;
      var defheight = 1080;
      var xScale = bodydom.clientWidth / defwidth;
      var yScale = bodydom.clientHeight / defheight;
      editordom.style.cssText +=
        ";transform: scale(" + xScale + "," + yScale + ")";

      $(window).resize(function () {
        xScale = bodydom.clientWidth / defwidth;
        yScale = bodydom.clientHeight / defheight;
        editordom.style.cssText +=
          ";transform: scale(" + xScale + "," + yScale + ")";
      });

      // var _this = this;
      // window.addEventListener("resize", function (e) {
      //   _this.$nextTick(() => {
      //     console.log("111111", _this.$refs.pie2);
      //     _this.key++;
      //   });
      // });
    },
    indexClick() {
      this.topTitle = "锐仕方达运营大数据中心";
      this.$router.push({ path: "/" });
    },
    collectionClick() {
      this.topTitle = "锐仕方达回款大数据";
      this.$router.push({ path: "/Collection" });
    },
    achievementClick() {
      this.topTitle = "锐仕方达业绩大数据";
      this.$router.push({ path: "/Achievement" });
    },
    managementClick() {
        this.topTitle = "锐仕方达经营大数据";
      this.$router.push({ path: "/Management" });
    // let routeUrl = this.$router.resolve({
        //     path: "/Management",
    //   });
    //   window.open(routeUrl.href, "_blank");
    },
    businessClick() {
        this.topTitle = "锐仕方达业务大数据";
        this.$router.push({ path: "/Business" });
    },
    personnelClick() {
        this.topTitle = "锐仕方达人员大数据";
        this.$router.push({ path: "/Personnel" });
    },

    //   点击打开全屏和退出全屏
    //控制全屏
    // 点击按钮触发的方法
    toggleFullscreen() {
      this.is = !this.is;
      console.log("[ this.is ] >", this.is);
      if (this.is) {
        this.$router.go(0);
      }
      console.log(this.is);
      this.flag++;
      this.flag % 2 == 0
        ? this.outFullCreeen(document)
        : this.FullCreeen(document.documentElement);
    },
    // 进入全屏的方法
    FullCreeen(element) {
      let el = element;
      let rfs =
        el.requestFullScreen ||
        el.webkitRequestFullScreen ||
        el.mozRequestFullScreen ||
        el.msRequestFullScreen;
      // Element.requestFullscreen() 此方法用于发出异步请求使元素进入全屏模式。
      // 调用此API并不能保证元素一定能够进入全屏模式。如果元素被允许进入全屏幕模式，
      // document对象会收到一个fullscreenchange事件，通知调用者当前元素已经进入全屏模式。如果全屏请求不被许可，则会收到一个fullscreenerror事件。
      if (typeof rfs != "undefined" && rfs) {
        rfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    //退出全屏的方法
    outFullCreeen(element) {
      let el = element;
      let cfs =
        el.cancelFullScreen ||
        el.webkitCancelFullScreen ||
        el.mozCancelFullScreen ||
        el.exitFullScreen;
      if (typeof cfs != "undefined" && cfs) {
        cfs.call(el);
      } else if (typeof window.ActiveXObject != "undefined") {
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript != null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
  },
  mounted() {
    // this.pieOutlineFunc();
  },

};
</script>

<style>
* {
  margin: 0;
  padding: 0;
}
.wrap {
  background: #010a1e;
  width: 100%;
  height: 100vh;
  margin: 0;
  padding: 0;
}
#app {
  background: #010a1e;
  width: 100%;
  height: 100vh;
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin: 0;
  padding: 0;
}
.top-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 7%;
  text-align: center;
  background: url(./assets/img/topSmallSize.png) no-repeat;
  background-size: 100%;
}
.top-text {
  color: #ffffff;
  flex: 1;
  line-height: 3em;
  letter-spacing: 2px;
  text-shadow: 0px 0px 12px #5363ff;
  font-size: 26px;
  font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
  font-weight: bold;
  text-indent: 8em;
}
.top-right-btn {
  padding-top: 16px;
  margin-right: 30px;
}
.top-button {
  padding: 5px 12px 5px 12px;
  border: 1px solid #1ac9ff;
  border-radius: 4px;
  color: #ffffff;
  font-size: 14px;
  display: inline-block;
}
.fullScreen:hover {
  border: none;
  padding: 8px 13px;
  background: #1c82ff;
  cursor: pointer;
}
.el-dropdown-link {
  cursor: pointer;
  color: #fff;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 1px;
}
.el-dropdown-menu {
  background: #010a1e;
  border: 1px solid #1ac9ff;
}
.el-dropdown-menu__item {
  color: #fff;
}
.el-dropdown-menu__item a {
  color: none;
}
.el-dropdown-menu__item:hover {
  background: none !important;
}
.fullScreen {
  font-size: 14px;
}
.icon-all {
  display: inline-block;
  width: 14px;
  height: 14px;
  position: relative;
  top: 3px;
}
.el-select-dropdown {
  background: #fff !important;
  border: 1px solid #20bcfc;
  top: 122px !important;
}
.el-picker-panel {
  background: #fff !important;
  border: 1px solid #20bcfc;
}
.el-date-picker__header-label {
  color: #010a1e;
}
.el-year-table td .cell {
  color: #010a1e;
}
.el-select-dropdown__item {
  color: #010a1e;
}
.el-select-dropdown__item.selected {
  color: #333;
  background: #F5F7FA;
}
.popper__arrow {
  display: none !important;
}
.el-icon-d-arrow-left:before,
.el-icon-d-arrow-right:before {
  color: #20bcfc;
}
.el-date-picker__header--bordered {
  border-bottom: 1px solid #20bcfc;
}
.el-year-table td.disabled .cell {
  background: none !important;
}

@media (max-width: 1600px) {
  .n-change {
    /* padding: 0 8px; */
    position: relative;
    /* top: 2px; */
  }
  .fullScreen {
    font-size: 12px;
    padding: 6px 8px 6px 8px;
    top: 1px;
    position: relative;
  }
  .fullScreen:hover {
    border: none;
    font-size: 12px;
    padding: 5px 9px;
    background: #1c82ff;
    cursor: pointer;
  }
  .el-dropdown {
    vertical-align: middle;
  }
  .top-right-btn {
    padding-top: 0;
  }
}
@media (max-width: 1366px) {
  .el-dropdown-menu {
    left: 1086px !important;
    top: 34px !important;
  }
  .top-text {
    font-size: 20px;
  }
}
.chrome-hosts-manager-ipaddr{
    display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue